import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { computed, reactive, ref, onBeforeUnmount } from "vue";
import { List, EditPen, Loading, Timer } from "@element-plus/icons-vue";
import MenuBox from "@/components/exam/MenuBox.vue";
import mcq from "@/components/examItem/item-mcq.vue";
import saq from "@/components/examItem/item-saq.vue";
import vocabulary_mcq from "@/components/examItem/item-vocabulary-mcq.vue";
import { useRoute } from "vue-router";
import { ElLoading, ElMessage } from "element-plus";
import { SetResumeApi, NextVocabularyApi, SubmitExamApi } from "@/api/vocabularyApi.js";
import { ElMessageBox } from "element-plus";
let examId = "";
let route;
export default {
  components: {
    MenuBox,
    vocabulary_mcq,
    mcq,
    saq
  },
  props: ["examInfo", "netState"],
  setup(props, content) {
    let paperInfo = reactive({});
    let stage = ref(0);
    let step = ref(0);
    let cache = reactive({});
    let menuRe = ref(false);
    let stageChangeFlag = ref(false);
    let exampleAnswer = reactive(["A", "D", ["A", "B"], ["A", "B"], "D"]);
    let reRender = ref(true);
    route = useRoute();
    examId = route.query.examId || route.query.examid;
    let itemNo = computed(() => {
      return paperInfo.items[cache.curItemNo - 1] ? cache.curItemNo - 1 : 0;
    });
    let {
      getPaper,
      upDatePaper
    } = usePaper(paperInfo, props.examInfo, cache, step, stage);
    let {
      nextStage,
      setAnswer,
      setCache,
      nextItem
    } = useAnswer(cache, paperInfo, props, content, step, upDatePaper, stage, itemNo, menuRe, stageChangeFlag, reRender);
    let {
      stageNo,
      timeText,
      setCountDown,
      finishExam
    } = useExamProcess(paperInfo, content, cache, step, stage, nextItem, itemNo, setCache);
    getPaper(setCountDown);
    return {
      reRender,
      nextStage,
      setAnswer,
      timeText,
      stageNo,
      setCountDown,
      finishExam,
      itemNo,
      step,
      paperInfo,
      cache,
      stage,
      List,
      EditPen,
      Loading,
      Timer,
      nextItem,
      menuRe,
      stageChangeFlag,
      exampleAnswer
    };
  }
};
//获取试卷
function usePaper(paperInfo, examInfo, cache, step, stage) {
  let reSetCountDown;
  //获取试卷
  function getPaper(setCountDown) {
    reSetCountDown = setCountDown;
    //试卷
    Object.assign(paperInfo, examInfo);
    //缓存
    Object.assign(cache, examInfo);
    cache.curItemNo = cache.curItemNo || 1;
    cache.curItemIndex = cache.curItemIndex || 1;
    cache.answer = cache.answer ? JSON.parse(cache.answer) : {};
    cache.curQIndex = cache.curQIndex || 1;
    cache.daojishi = cache.daojishi || 300;
    delete cache.items;
    //设置数据
    stage.value = cache.curStage ? cache.curStage.indexOf("-") - 1 : 0;
    step.value = cache.curStage ? cache.curStage.slice(-1) - 1 : 0;
    useSettingPaper(paperInfo, cache);
    //倒计时
    if (stage.value == 2) setCountDown();
  }
  //更新试卷
  function upDatePaper(nextExamInfo) {
    cache.curStage = nextExamInfo.curStage;
    paperInfo.items.splice(0, paperInfo.items.length);
    Object.assign(paperInfo, nextExamInfo);
    cache.curItemNo = nextExamInfo.curItemNo - 0;
    cache.curItemIndex = nextExamInfo.curItemIndex;
    cache.curItemId = paperInfo.items[cache.curItemNo - 1] ? paperInfo.items[cache.curItemNo - 1].itemId : paperInfo.items[0].itemId;
    cache.answer = JSON.parse(nextExamInfo.answer);
    cache.curQIndex = cache.curQIndex - 0 >= nextExamInfo.curQIndex - 0 ? cache.curQIndex - 0 + 1 : nextExamInfo.curQIndex;
    cache.daojishi = 300;
    delete cache.items;
    //设置数据
    stage.value = cache.curStage.indexOf("-") - 1;
    step.value = cache.curStage ? cache.curStage.slice(-1) - 1 : 0;
    useSettingPaper(paperInfo, cache);
    //倒计时
    if (stage.value == 2) reSetCountDown();
    // setCountDown();
  }
  return {
    getPaper,
    upDatePaper
  };
}
//目录
function useSettingPaper(paperInfo, cache) {
  let task = 1;
  let preNo = 1;
  if (paperInfo.items.length > 1) {
    for (let i = 0; i < cache.curItemNo - 1; i++) {
      preNo += paperInfo.items[i].questionGroupList.length;
    }
  }
  window.localStorage.setItem("preTotalNo-" + (route.query.examid || route.query.examId), cache.curQIndex - cache.curItemNo > 0 && paperInfo.items.length > 1 ? cache.curQIndex - preNo : cache.curQIndex - 1);
  paperInfo.items.forEach(items => {
    items.menu = cache.curQIndex - cache.curItemNo > 0 && paperInfo.items.length > 1 ? cache.curQIndex - preNo + task : cache.curQIndex - 1 + task;
    items.questionGroupList.forEach(group => {
      if (group.questionList) {
        group.questionList.forEach(() => {
          task++;
        });
      } else {
        task++;
      }
    });
  });
}
//流程控制(倒计时，交卷)
function useExamProcess(paperInfo, content, cache, step, stage, nextItem, itemNo, setCache) {
  let countDownTimer;
  let countTimer;
  let stageNo = ["I", "II", "III"];
  let timeText = ref("00:00:00");
  onBeforeUnmount(() => {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
  });
  //启动倒计时
  function setCountDown() {
    let time = cache.daojishi;
    if (countDownTimer) countDownTimer.close();
    countDownTimer = new WebSocket("wss://unilearn.fltrp.com/jzws/count-down");
    countDownTimer.onopen = () => {
      countDownTimer.send(time + ":1:" + examId);
    };
    countDownTimer.onmessage = evt => {
      time = evt.data;
      if (time <= 0) {
        finishExam(2);
      } else {
        let s = time % 60;
        let m = parseInt(time / 60) % 60;
        let h = parseInt(parseInt(time / 60) / 60);
        timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
        cache.daojishi = time;
        //自动缓存(30s)
        if (time % 30 == 0) {
          setCache();
        }
      }
    };
    countDownTimer.onclose = e => {
      if (!e.wasClean && window.navigator.onLine && countDownTimer && countDownTimer.readyState != 0) {
        countDownTimer.close();
        setCountDown();
      }
    };
  }
  // function setCountDown() {
  //   let time = cache.daojishi;
  //   if (countTimer) clearInterval(countTimer);
  //   countTimer = setInterval(() => {
  //     time--;
  //     if (time <= 0) {
  //       finishExam(2);
  //     } else {
  //       let s = time % 60;
  //       let m = parseInt(time / 60) % 60;
  //       let h = parseInt(parseInt(time / 60) / 60);
  //       timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
  //         s > 9 ? s : "0" + s
  //       }`;
  //       cache.daojishi = time;
  //       //自动缓存(30s)
  //       if (time % 30 == 0) {
  //         setCache();
  //       }
  //     }
  //   }, 1000);
  // }

  //交卷(1手动交卷 2倒计时结束被交卷)
  function finishExam(type) {
    if (type == 1) {
      ElMessageBox.confirm(`确认交卷吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi();
      });
    } else if (type == 2) {
      //切换题目
      if (step.value == 0) {
        nextItem(null, true);
      } else if (step.value == 1) {
        ElMessage({
          type: "warning",
          showClose: true,
          message: "倒计时结束，自动交卷"
        });
        finishExamApi();
      }
    }
  }
  function finishExamApi() {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
    let data = {
      curItemId: cache.curItemId || paperInfo.items[itemNo.value].questionGroupList[0].itemId,
      curItemIndex: cache.curItemIndex,
      curItemNo: cache.curItemNo,
      curQIndex: paperInfo.items[itemNo.value].menu,
      curStage: stageNo[stage.value] + "-" + (step.value + 1),
      answer: {
        ...cache.answer
      },
      examId: examId,
      version: new Date().getTime()
    };
    const loading = ElLoading.service({
      lock: true,
      text: "正在提交考试..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    SubmitExamApi({
      ...data
    }).then(() => {
      ElMessage({
        type: "success",
        showClose: true,
        message: "提交成功"
      });
      setTimeout(() => {
        loading.close();
        content.emit("finishExam");
      }, 1000);
    });
  }
  return {
    timeText,
    setCountDown,
    finishExam,
    stageNo
  };
}
//缓存 答案
function useAnswer(cache, paperInfo, props, content, step, upDatePaper, stage, itemNo, menuRe, stageChangeFlag, reRender) {
  let loading;
  let stageNo = ["I", "II", "III"];
  let usedTime = new Date().getTime();
  let nextMsg;
  //设置答案
  function setAnswer(msg) {
    for (let key in msg) {
      cache.answer[key] = msg[key];
    }
    setCache(0);
  }
  //设置缓存
  function setCache(usedTime = 0, fn) {
    let data = {
      curItemId: cache.curItemId || paperInfo.items[itemNo.value].questionGroupList[0].itemId,
      curItemIndex: cache.curItemIndex,
      curItemNo: cache.curItemNo,
      curQIndex: paperInfo.items[itemNo.value].menu,
      curStage: stageNo[stage.value] + "-" + (step.value + 1),
      daojishi: cache.daojishi,
      answer: {
        ...cache.answer
      },
      examId: examId,
      usedTime: usedTime ? new Date().getTime() - usedTime : 0,
      version: new Date().getTime()
    };
    if (loading && usedTime === null) {
      loading.close();
      return 0;
    }
    if (props.netState) {
      window.localStorage.removeItem("cache-" + examId);
      SetResumeApi(data).then(r => {
        // if (r.status == 404) {
        //   ElMessage({
        //     type: "error",
        //     showClose: true,
        //     message: "您的考试已被强制提交。",
        //   });
        //   content.emit("finishExam");
        // } else
        if (r.status == 406) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的考试已被重置。"
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (r.status == 403) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的登录已失效或在别处登录"
          });
          setTimeout(() => {
            window.closed();
          }, 2000);
        } else {
          fn ? fn() : "";
        }
      });
    } else {
      data.interruptMark ? data.interruptMark = JSON.stringify(data.interruptMark) : "";
      window.localStorage.setItem("cache-" + examId, JSON.stringify(data));
    }
  }
  function nextItem(no = cache.curItemNo, change = stage.value == 2 && step.value == 0 && !paperInfo.items[no]) {
    if (paperInfo.items[no] && !change) {
      setCache(usedTime);
      usedTime = new Date().getTime();
      cache.curItemId = paperInfo.items[no].itemId;
      cache.curItemNo = no - 0 + 1;
      cache.curItemIndex = no - 0 + 1;
      return 0;
    } else if (stage.value == 2 && step.value == 1) {
      ElMessage({
        type: "warning",
        showClose: true,
        message: "当前为最后一题。"
      });
      return 0;
    }
    let data = {
      curItemId: cache.curItemId || paperInfo.items[itemNo.value].questionGroupList[0].itemId,
      curItemIndex: cache.curItemIndex,
      curItemNo: cache.curItemNo,
      curQIndex: paperInfo.items[itemNo.value].menu + 1,
      curStage: stageNo[stage.value] + "-" + (step.value + 1),
      answer: {
        ...cache.answer
      },
      examId: examId,
      version: new Date().getTime()
    };
    // alert(paperInfo.items[itemNo.value].menu + 1);
    if (change) {
      let no = paperInfo.items.length - 1;
      data.curItemId = paperInfo.items[no].questionGroupList[0].itemId;
      data.curQIndex = paperInfo.items[no].menu + 2;
      data.curItemNo = paperInfo.items.length;
      data.curItemIndex = paperInfo.items.length;
    }
    loading = ElLoading.service({
      lock: true,
      text: "提交中..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    menuRe.value = false;
    setCache(usedTime, () => {
      reRender.value = false;
      NextVocabularyApi(data).then(r => {
        reRender.value = true;
        if (r.status < 400) {
          //部分完成
          if (r.data.curStage.indexOf("-") - 1 > stage.value) {
            nextMsg = r.data;
            loading.close();
            stageChangeFlag.value = true;
          } else {
            setCache(null);
            usedTime = new Date().getTime();
            upDatePaper(r.data);
            menuRe.value = r.data.curItemNo - 1;
          }
        } else {
          ElMessage({
            type: "error",
            showClose: true,
            message: "保存答案失败，请稍后再试。"
          });
        }
      });
    });
  }
  function nextStage() {
    stageChangeFlag.value = false;
    setCache(null);
    usedTime = new Date().getTime();
    upDatePaper(nextMsg);
    menuRe.value = nextMsg.curItemNo - 1;
  }
  return {
    nextStage,
    setAnswer,
    setCache,
    nextItem
  };
}